
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "tools-required-to-build-and-run-apache-atlas-on-eclipse"
    }}>{`Tools required to build and run Apache Atlas on Eclipse`}</h1>
    <p>{`These instructions are provided as-is. They worked at a point in time; other variants of software may work. These instructions may become stale if the build dependencies change.`}</p>
    <p>{`They have been shown to work on 19th of December 2016.`}</p>
    <p>{`To build, run tests, and debug Apache Atlas, the following software is required:`}</p>
    <p><strong parentName="p">{`Java`}</strong></p>
    <ul>
      <li parentName="ul">{`Download and install a 1.8 Java SDK`}</li>
      <li parentName="ul">{`Set JAVA_HOME system environment variable to the installed JDK home directory`}</li>
      <li parentName="ul">{`Add JAVA_HOME/bin directory to system PATH`}</li>
    </ul>
    <p><strong parentName="p">{`Python`}</strong>{`
Atlas command line tools are written in Python.`}</p>
    <ul>
      <li parentName="ul">{`Download and install Python version 2.7.7`}</li>
      <li parentName="ul">{`For Mac, we used 2.7.11`}</li>
      <li parentName="ul">{`Add Python home directory to system PATH`}</li>
    </ul>
    <p><strong parentName="p">{`Maven`}</strong></p>
    <ul>
      <li parentName="ul">{`Download and install Maven 3.3.9`}</li>
      <li parentName="ul">{`Set the environment variable M2_HOME to point to the maven install directory`}</li>
      <li parentName="ul">{`Add M2_HOME/bin directory to system PATH e.g. C:\\Users\\IBM_ADMIN\\Documents\\Software\\apache-maven-3.3.9\\bin`}</li>
    </ul>
    <p><strong parentName="p">{`Git`}</strong></p>
    <ul>
      <li parentName="ul">{`Install Git`}</li>
      <li parentName="ul">{`Add git bin directory to the system PATH e.g. C:\\Program Files (x86)\\Git\\bin`}</li>
    </ul>
    <p><strong parentName="p">{`Eclipse`}</strong></p>
    <ul>
      <li parentName="ul">{`Install Eclipse Neon (4.6)`}</li>
      <li parentName="ul">{`The non-EE Neon for iOS from eclipse.org has been proven to work here.`}</li>
      <li parentName="ul">{`Install the Scala IDE, TestNG, and m2eclipse-scala features/plugins as described below.`}</li>
    </ul>
    <p><strong parentName="p">{`Scala IDE Eclipse feature`}</strong>{`
Some of the Atlas source code is written in the Scala programming language. The Scala IDE feature is required to compile Scala source code in Eclipse.`}</p>
    <ul>
      <li parentName="ul">{`In Eclipse, choose Help - Install New Software..`}</li>
      <li parentName="ul">{`Click Add... to add an update site, and set Location to `}<a parentName="li" {...{
          "href": "http://download.scala-ide.org/sdk/lithium/e44/scala211/stable/site"
        }}>{`http://download.scala-ide.org/sdk/lithium/e44/scala211/stable/site`}</a></li>
      <li parentName="ul">{`Select Scala IDE for Eclipse from the list of available features`}</li>
      <li parentName="ul">{`Restart Eclipse after install`}</li>
      <li parentName="ul">{`Set the Scala compiler to target the 1.7 JVM: Window - Preferences - Scala - Compiler, change target to 1.7
`}<em parentName="li">{`TestNG Eclipse plug-in`}</em></li>
    </ul>
    <p>{`Atlas tests use the `}<a parentName="p" {...{
        "href": "http://testng.org/doc/documentation-main.html"
      }}>{`TestNG framework`}</a>{`, which is similar to JUnit. The TestNG plug-in is required to run TestNG tests from Eclipse.`}</p>
    <ul>
      <li parentName="ul">{`In Eclipse, choose Help - Install New Software..`}</li>
      <li parentName="ul">{`Click Add... to add an update site, and set Location to `}<a parentName="li" {...{
          "href": "http://beust.com/eclipse-old/eclipse_6.9.9.201510270734"
        }}>{`http://beust.com/eclipse-old/eclipse_6.9.9.201510270734`}</a>
        <pre parentName="li"><code parentName="pre" {...{}}>{`  * Choose TestNG and continue with install
  * Restart Eclipse after installing the plugin
  * In Window - Preferences - TestNG, <b>un</b>check "Use project TestNG jar"
`}</code></pre>
        <em parentName="li">{`m2eclipse-scala Eclipse plugin`}</em></li>
      <li parentName="ul">{`In Eclipse, choose Help - Install New Software..`}</li>
      <li parentName="ul">{`Click Add... to add an update site, and set Location to `}<a parentName="li" {...{
          "href": "http://alchim31.free.fr/m2e-scala/update-site/"
        }}>{`http://alchim31.free.fr/m2e-scala/update-site/`}</a></li>
      <li parentName="ul">{`Choose Maven Integration for Scala IDE, and continue with install`}</li>
      <li parentName="ul">{`Restart Eclipse after install`}</li>
      <li parentName="ul">{`In Window - Preferences -Maven - Errors/Warnings, set Plugin execution not covered by lifecycle configuration to Warning
`}<em parentName="li">{`Import Atlas maven projects into Eclipse:`}</em></li>
    </ul>
    <p>{`a. File - Import - Maven - Existing Maven Projects b. Browse to your Atlas folder c. Uncheck the root project and non-Java projects such as dashboardv2, docs and distro, then click Finish`}</p>
    <p>{`On the Mac, the Maven import fails with message`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`"Cannot complete the install because one or more required items could not be found.
Software being installed: Maven Integration for AJDT (Optional) 0.14.0.201506231302 (org.maven.ide.eclipse.ajdt.feature.feature.group 0.14.0.201506231302)
Missing requirement: Maven Integration for AJDT (Optional) 0.14.0.201506231302 (org.maven.ide.eclipse.ajdt.feature.feature.group 0.14.0.201506231302) requires 'org.eclipse.ajdt.core 1.5.0' but it could not be found".`}
    </SyntaxHighlighter>
    <p>{`Install `}<a parentName="p" {...{
        "href": "http://download.eclipse.org/tools/ajdt/46/dev/update"
      }}>{`http://download.eclipse.org/tools/ajdt/46/dev/update`}</a>{` and rerun. The Maven AspectJ should plugin install - allowing the references to Aspects in Maven to be resolved.`}</p>
    <p>{` d. In the atlas-typesystem, atlas-repository, hdfs-model, and storm-bridge projects, add the src/main/scala and src/test/scala (if available) directories as source folders. Note: the hdfs-model and storm-bridge projects do not have the src/test/scala folder.`}</p>
    <p>{`Right-click on the project, and choose `}<em parentName="p">{`Properties`}</em>{`.`}</p>
    <p>{`Click the `}<em parentName="p">{`Java Build Path`}</em>{` in the left-hand panel, and choose the `}<em parentName="p">{`Source`}</em>{` tab.`}</p>
    <p>{`Click `}<em parentName="p">{`Add Folder`}</em>{`, and select the src/main/scala and src/test/scala directories.`}</p>
    <p>{`Only the atlas-repository and atlas-type system projects have Scala source folders to update.`}</p>
    <p>{`e. Select atlas-typesystem, atlas-repository, hdfs-model, and storm-bridge projects, right-click, go to the Scala menu, and choose ‘Set the Scala Installation’.`}</p>
    <p>{`f. Choose Fixed Scala Installation: 2.11.8 (bundled) , and click OK.`}</p>
    <p>{`g. Restart Eclipse`}</p>
    <p>{`h. Choose Project - Clean, select Clean all projects, and click OK.`}</p>
    <p>{`Some projects may not pick up the Scala library – if this occurs, quick fix on those projects to add in the Scala library – projects atlas-typesystem, atlas-repository, hdfs-model, storm-bridge and altas-webapp.`}</p>
    <p>{`You should now have a clean workspace.`}</p>
    <p><em parentName="p">{`Sample Bash scripts to help mac users`}</em></p>
    <p>{`You will need to change some of these scripts to point to your installation targets.`}</p>
    <ul>
      <li parentName="ul">{`Run this script to setup your command line build environment`}</li>
    </ul>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`#!/bin/bash # export JAVA_HOME=/Library/Java/JavaVirtualMachines/macosxx6480sr3fp10hybrid-20160719_01-sdk
export JAVA_HOME=/Library/Java/JavaVirtualMachines/jdk1.8.0_101.jdk/Contents/Home
export M2_HOME=/Applications/apache-maven-3.3.9 # Git is installed in the system path
export PYTHON_HOME='/Applications/Python 2.7'
export PATH=$PYTHON_HOME:$M2_HOME/bin:$JAVA_HOME/bin:$PATH
export MAVEN_OPTS="-Xmx1536m -Drat.numUnapprovedLicenses=100"`}
    </SyntaxHighlighter>
    <ul>
      <li parentName="ul">{`If you do  not want to set Java 8 as your system java, you can use this  bash script to setup the environment and run Eclipse (which you can drop in Applications and rename to neon).`}</li>
    </ul>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`#!/bin/bash
export JAVA_HOME=/Library/Java/JavaVirtualMachines/jdk1.8.0_101.jdk/Contents/Home
export M2_HOME=/Applications/apache-maven-3.3.9
# Git is installed in the system path
export PYTHON_HOME='/Applications/Python 2.7'
export PATH=$PYTHON_HOME:$M2_HOME/bin:$JAVA_HOME/bin:$PATH/Applications/neon.app/Contents/MacOS/eclipse`}
    </SyntaxHighlighter>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;